import { gql, useQuery } from '@apollo/client'

import {
  OfficialInformationDetailQuery,
  OfficialInformationDetailQueryVariables,
  OrganizationNotificationBoxFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ notificationId: string }>()

  const artistId = config.artistId ?? ''
  const { data, loading } = useQuery<
    OfficialInformationDetailQuery,
    OfficialInformationDetailQueryVariables
  >(QUERY, {
    variables: { notificationId: router.query.notificationId },
  })

  return {
    state: {
      loading,
      notification: data?.organizationOfficialNotification ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query OfficialInformationDetail($notificationId: ID!) {
    organizationOfficialNotification(id: $notificationId) {
      ...OrganizationNotificationBox
    }
  }
  ${OrganizationNotificationBoxFragmentDoc}
`

const ARTIST_QUERY = gql`
  query OfficialInformationDetailArtist($artistId: ID!) {
    artist(id: $artistId) {
      displayName
      avatar {
        uri
        smallUri
      }
    }
  }
`
